import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchHomeworksPage } from '@services/registry';

export function useHomeworks({ tenantId, page = 1, pageSize = 10 }) {
    const cursorByPageRef = useRef(new Map([[1, null]]));

    useEffect(() => {
        cursorByPageRef.current = new Map([[1, null]]);
    }, [tenantId, pageSize]);

    const homeworksQuery = useQuery({
        queryKey: ['homeworks', tenantId, page, pageSize],
        queryFn: async () => {
            const cursor = cursorByPageRef.current.get(page);
            if (page > 1 && typeof cursor === 'undefined') {
                throw new Error('Pagination cursor missing. Please go page-by-page.');
            }
            const res = await fetchHomeworksPage({
                tenantId,
                pageSize,
                cursor: cursor ?? null,
            });
            cursorByPageRef.current.set(page + 1, res.nextCursor || null);
            return res;
        },
        enabled: !!tenantId,
        staleTime: 2 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });

    return {
        rows: homeworksQuery.data?.rows || [],
        total: homeworksQuery.data?.total || 0,
        loading: homeworksQuery.isLoading,
        error: homeworksQuery.error || null,
    };
}
